// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___ahuto {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}
.styles__container___ahuto section {
  margin-bottom: 45px;
}
.styles__footer___UGndL {
  padding: 10px;
}
@media (max-width: 991px) {
  .styles__footer___UGndL {
    margin-left: -31px !important;
    margin-right: -31px !important;
    margin-bottom: -16px !important;
    height: 80px;
  }
}
.styles__mainContent___pMbUD {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-left: auto;
  margin-right: auto;
  background: #fff;
  border-radius: 4px;
  padding: 36px;
}
.styles__mainContent___pMbUD section {
  margin-bottom: 45px;
}
@media (max-width: 991px) {
  .styles__mainContent___pMbUD {
    padding: 16px;
  }
}
.styles__transparentBackground___SBu6f {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  background: transparent;
  box-shadow: none;
}
.styles__transparentBackground___SBu6f section {
  margin-bottom: 45px;
}
.styles__productsList___KPR0F {
  padding: 0 15px;
  width: 100%;
}
.styles__productTotal___aropm {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.styles__totalPrice___Gq8XZ {
  font-size: 24px;
  margin-left: 8px;
}
@media (max-width: 991px) {
  .styles__price___EIQYg {
    text-align: right;
  }
}
.styles__checkoutCustomText___KwmLp {
  white-space: pre-wrap;
}
.styles__selector___cxngp {
  width: 200px;
  margin-top: 10px;
}
@media (max-width: 991px) {
  .styles__selector___cxngp {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/layout.less","webpack://./src/components/components/CheckoutComponent/styles.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ACDF;ADTA;EAYI,mBAAA;ACAJ;AAXA;EACE,aAAA;AAaF;AAZE;EAAA;IACE,6BAAA;IACA,8BAAA;IACA,+BAAA;IACA,YAAA;EAeF;AACF;AAZA;EDVE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EAEA,iBAAA;EACA,kBAAA;ECGA,gBAAA;EACA,kBAAA;EACA,aAAA;AAsBF;AA1BA;EDCI,mBAAA;AC4BJ;AAxBE;EAAA;IACE,aAAA;EA2BF;AACF;AAxBA;EDpBE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ECaA,uBAAA;EACA,gBAAA;AAmCF;AAtCA;EDTI,mBAAA;ACkDJ;AAnCA;EACE,eAAA;EACA,WAAA;AAqCF;AAlCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAoCF;AAjCA;EACE,eAAA;EACA,gBAAA;AAmCF;AA/BE;EAAA;IACE,iBAAA;EAkCF;AACF;AA/BA;EACE,qBAAA;AAiCF;AA9BA;EACE,YAAA;EACA,gBAAA;AAgCF;AA9BE;EAAA;IACE,WAAA;EAiCF;AACF","sourcesContent":["@import './variables.less';\n\n.container {\n  max-width: 1140px !important;\n  margin-top: 20px;\n  margin-bottom: 15px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: @eon-box-shadow;\n  transition: @eon-transition-default;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  section {\n    margin-bottom: 45px;\n  }\n}\n","@import '../../../shared/variables.less';\n@import '../../../shared/layout.less';\n\n.footer {\n  padding: 10px;\n  @media (max-width: 991px) {\n    margin-left: -31px !important;\n    margin-right: -31px !important;\n    margin-bottom: -16px !important;\n    height: 80px;\n  }\n}\n\n.mainContent {\n  .container();\n  background: @eon-checkout-section-background;\n  border-radius: 4px;\n  padding: 36px;\n  @media (max-width: 991px) {\n    padding: 16px;\n  }\n}\n\n.transparentBackground {\n  .container();\n  background: transparent;\n  box-shadow: none;\n}\n\n.productsList {\n  padding: 0 15px;\n  width: 100%;\n}\n\n.productTotal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.totalPrice {\n  font-size: 24px;\n  margin-left: 8px;\n}\n\n.price {\n  @media (max-width: 991px) {\n    text-align: right;\n  }\n}\n\n.checkoutCustomText {\n  white-space: pre-wrap;\n}\n\n.selector {\n  width: 200px;\n  margin-top: 10px;\n\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___ahuto`,
	"footer": `styles__footer___UGndL`,
	"mainContent": `styles__mainContent___pMbUD`,
	"transparentBackground": `styles__transparentBackground___SBu6f`,
	"productsList": `styles__productsList___KPR0F`,
	"productTotal": `styles__productTotal___aropm`,
	"totalPrice": `styles__totalPrice___Gq8XZ`,
	"price": `styles__price___EIQYg`,
	"checkoutCustomText": `styles__checkoutCustomText___KwmLp`,
	"selector": `styles__selector___cxngp`
};
export default ___CSS_LOADER_EXPORT___;
